<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/tuscany')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/avignonesi')">Avignonesi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country two-line"
                               :to="localePath('/wine-guide/italy/tuscany/azienda-agricola-casanova-di-neri')">Azienda
                        Agricola Casanova di Neri
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/azienda-salvioni')">Azienda Salvioni
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/castiglione-del-bosco')">Castiglione del Bosco
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/conti-constani')">Conti Constani
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fattoria-le-pupille')">Fattoria Le Pupille
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/italy/tuscany/fattoria-poggio-di-sotto')">Fattoria Poggio di
                        Sotto
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fontodi')">Fontodi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/frescobaldi')">Frescobaldi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/gianfranco-soldera')">Gianfranco Soldera
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/isole-e-olena')">Isole e Olena
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/marchesi-antinori')">Marchesi Antinori
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/podere-poggio-scalette')">Podere Poggio
                        Scalette
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/poderi-boscarelli')">Poderi Boscarelli
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/rocca-di-frassinello')">Rocca di Frassinello
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-dell-ornellaia')">Tenuta dell’Ornellaia
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-di-trinoro')">Tenuta di Trinoro
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-san-guido')">Tenuta San Guido
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/tuscany')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Fattoria Poggio di Sotto</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Considerando la sua fama, il Brunello è relativamente nuovo nel meraviglioso mondo degli investimenti nel vino.
                        La regione è emersa nel radar della viticoltura solo negli anni '70 (finora era stata italiana
                        il segreto meglio custodito degli enofili) e da allora la regione è esplosa in popolarità. Questo ha portato
                        ad alcune gemme in via di scoperta, come la Fattoria Poggio di Sotto.
                    </div>

                    <div class="howto-title2">Fare i compiti conviene</div>
                    <div class="howto-text">
                        Fondato dal grande Piero Palmucci nel 1989, Poggio di Sotto è diventato molto rapidamente uno dei
                        I vini di punta del Chianti. La ricerca della location perfetta da parte di Piero è ben documentata: ha speso
                        anni guidando per Montalcino alla ricerca di tipi di suolo, parlando con la gente del posto, chiedendo agli esperti
                        e in attesa che si presenti l'occasione giusta. Infine una tenuta a Castelnuovo dell'Abate
                        nel sud della Toscana è arrivato sul mercato e l'ha acquistato più in fretta di quanto si possa battere ciglio.
                        Lavorare a stretto contatto con gli studiosi dell'Università degli Studi di Milano per i cloni perfetti di Sangiovese
                        (basterebbe solo una singola varietà), insieme hanno costruito un piano di ottimizzazione dei vigneti da
                        semina alla potatura. Scegliendo un approccio organico al 100%, Piero aveva trovato l'oro; tutti gli aspetti
                        uniti e aveva la stoffa di un vino di prim'ordine.
                    </div>

                    <div class="howto-title2">La Borgogna del Brunello</div>
                    <div class="howto-text">
                        Nel corso degli anni si è costruito una reputazione come uno dei principali (e forse il più sgradevole) del Brunello
                        produttori. Palmucci vendette Poggio di Sotto a Claudio Tipa, proprietario di ColleMassari e Grattamacco,
                        nel 2011, e per fortuna Tipa ha continuato a operare con gli stessi standard di qualità e
                        tecniche di produzione come predecessore di Poggio. Ciò include rese estremamente basse ed estensive
                        botti invecchiate che insieme producono quello che critici, collezionisti e investitori chiamano “il
                        Borgogna del Brunello”.
                    </div>

                    <div class="howto-title2">Il Brunello è un diamante tra i vini toscani</div>
                    <div class="howto-text">
                        Poggio di Sotto deve la sua fama stellare ai tre sublimi Montalcino: il Rosso, il Brunello e l'iconica Riserva. Nel 2001 l'azienda ha prodotto anche il setoso liscio e
                        sempre più scarso il Brunello di Montalcino Il Decennale. Quest'ultimo vino ha mostrato una crescita superba
                        da aprile 2017-2019, in crescita del 100% in 24 mesi. Il Rosso è considerato da molti un
                        vino migliore di molti altri Brunello, mentre la Riserva è stata prodotta solo quattro volte da allora
                        1991. La qualità e la rarità hanno sicuramente un prezzo, ma credeteci, ne vale la pena.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Fattoria Poggio di Sotto</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Angesichts seiner Berühmtheit ist Brunello ein relativer Neuling in der wunderbaren Welt der Weininvestitionen.
                        Die Region tauchte erst in den 1970er Jahren auf dem Radar des Weinbaus auf (bisher war sie italienisch).
                        Das bestgehütete Geheimnis der Önophilen) und seitdem erfreut sich die Region immer größerer Beliebtheit. Dies hat dazu geführt
                        bis hin zu einigen Juwelen, die entdeckt werden, wie zum Beispiel der Fattoria Poggio di Sotto.
                    </div>

                    <div class="howto-title2">Es lohnt sich, seine Hausaufgaben zu machen</div>
                    <div class="howto-text">
                        Poggio di Sotto wurde 1989 vom großen Piero Palmucci gegründet und hat sich sehr schnell zu einem davon entwickelt
                        Die führenden Weine des Chianti. Pieros Suche nach dem perfekten Ort ist gut dokumentiert: Er verbrachte
                        Ich bin jahrelang durch Montalcino gefahren, habe Bodentypen erforscht, mit Einheimischen gesprochen und Experten befragt
                        und darauf warten, dass sich die richtige Gelegenheit ergibt. Schließlich ein Anwesen in Castelnuovo dell’Abate
                        in der südlichen Toskana kam auf den Markt und er schnappte es sich schneller, als man mit der Wimper zucken konnte.
                        Enge Zusammenarbeit mit den Wissenschaftlern der Universität Mailand für die perfekten Sangiovese-Klone
                        (Nur eine einzelne Sorte würde ausreichen) erstellten sie gemeinsam einen Plan zur Optimierung der Weinberge
                        vom Pflanzen bis zum Beschneiden. Mit der Entscheidung für einen 100 % organischen Ansatz war Piero goldrichtig. alle Aspekte
                        vereint und er hatte das Zeug zu einem erstklassigen Wein.
                    </div>

                    <div class="howto-title2">Der Burgunder von Brunello</div>
                    <div class="howto-text">
                        Im Laufe der Jahre baute er sich den Ruf eines der führenden (und vielleicht unangenehmsten) Brunellos auf.
                        Produzenten. Palmucci verkaufte Poggio di Sotto an Claudio Tipa, Besitzer von ColleMassari und Grattamacco,
                        im Jahr 2011, und zum Glück hat Tipa weiterhin nach den gleichen Qualitätsstandards gearbeitet
                        Produktionstechniken wie Poggios Vorgänger. Dazu gehören extrem niedrige Erträge und umfangreiche
                        Botti-Alterung, die zusammen das produzieren, was Kritiker, Sammler und Investoren als „das“ bezeichnen
                        Burgund von Brunello“.
                    </div>

                    <div class="howto-title2">Brunello ist ein Diamant unter den toskanischen Weinen</div>
                    <div class="howto-text">
                        Poggio di Sotto verdankt seinen hervorragenden Ruf den drei erhabenen Montalcinos: dem Rosso, dem Brunello und dem legendären Riserva. Im Jahr 2001 produzierte das Weingut auch das seidenweiche und
                        immer seltener Brunello di Montalcino Il Decennale. Dieser letztgenannte Wein zeigte ein hervorragendes Wachstum
                        von April 2017 bis 2019, Wachstum von 100 % über 24 Monate. Der Rosso wird von vielen als einer angesehen
                        besserer Wein als viele andere Brunellos, während die Riserva seitdem nur viermal hergestellt wurde
                        1991. Qualität und Seltenheit haben sicherlich ihren Preis, aber glauben Sie uns, es lohnt sich.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Fattoria Poggio di Sotto</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Compte tenu de sa renommée, Brunello est un nouveau venu dans le monde merveilleux de l'investissement dans le vin.
                        La région n'est apparue sur les radars viticoles que dans les années 1970 (jusqu'alors c'était l'Italie
                        le secret le mieux gardé des œnophiles) et depuis lors, la région a explosé en popularité. Cela a mené
                        à la découverte de quelques joyaux, comme la Fattoria Poggio di Sotto.
                    </div>

                    <div class="howto-title2">C'est payant de faire ses devoirs</div>
                    <div class="howto-text">
                        Fondé par le grand Piero Palmucci en 1989, Poggio di Sotto est très vite devenu l'un des
                        Les meilleurs vins du Chianti. La recherche de Piero pour l'emplacement parfait est bien documentée : il a passé
                        des années à conduire autour de Montalcino à rechercher des types de sols, à parler aux habitants, à demander aux experts
                        et attendant que la bonne occasion se présente. Finalement, un domaine à Castelnuovo dell'Abate
                        dans le sud de la Toscane est arrivé sur le marché et il l'a acheté plus vite que vous ne pouviez cligner des yeux.
                        Travailler en étroite collaboration avec les chercheurs de l'Université de Milan pour les clones parfaits de Sangiovese
                        (un seul cépage ferait l'affaire), ensemble ils ont construit un plan d'optimisation des vignobles de
                        de la plantation à la taille. En optant pour une approche 100 % biologique, Piero avait trouvé de l'or ; tous les aspects
                        unis et il avait l'étoffe d'un vin de premier ordre.
                    </div>

                    <div class="howto-title2">La Bourgogne de Brunello</div>
                    <div class="howto-text">
                        Au fil des ans, il s'est forgé une réputation comme l'un des principaux (et peut-être le plus désagréable) de Brunello
                        producteurs. Palmucci a vendu Poggio di Sotto à Claudio Tipa, propriétaire de ColleMassari et Grattamacco,
                        en 2011, et heureusement, Tipa a continué à fonctionner selon les mêmes normes de qualité et
                        techniques de production comme le prédécesseur de Poggio. Cela comprend des rendements extrêmement faibles et une vaste
                        botti vieillissement qui, combinés, produisent ce que les critiques, les collectionneurs et les investisseurs appellent "le
                        Bourgogne de Brunello ».
                    </div>

                    <div class="howto-title2">Brunello est un diamant parmi les vins toscans</div>
                    <div class="howto-text">
                        Poggio di Sotto doit sa réputation stellaire aux trois sublimes Montalcinos : le Rosso, le Brunello et l'iconique Riserva. En 2001, le domaine a également produit le soyeux et doux
                        de plus en plus rare Brunello di Montalcino Il Decennale. Ce dernier vin a montré une superbe croissance
                        d'avril 2017 à 2019, en croissance de 100 % sur 24 mois. Le Rosso est considéré par beaucoup comme un
                        meilleur vin que beaucoup d'autres Brunellos, alors que la Riserva n'a été faite que quatre fois depuis
                        1991. Qualité et rareté ont certes un prix mais croyez-nous, cela en vaut la peine.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Fattoria Poggio di Sotto</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Considering its fame, Brunello is a relative newcomer to the wonderful world of wine investment.
                        The region only surfaced on the viticultural radar in the 1970s (hitherto it had been Italian
                        oenophile’s best-kept secret) and since then the region has erupted in popularity. This has led
                        to some gems being discovered, such as Fattoria Poggio di Sotto.
                    </div>

                    <div class="howto-title2">It pays to do your homework</div>
                    <div class="howto-text">
                        Founded by the great Piero Palmucci in 1989, Poggio di Sotto has very quickly become one of
                        Chianti’s leading wines. Piero’s search for the perfect location is well documented: he spent
                        years driving around Montalcino researching soil types, talking to locals, asking the experts
                        and waiting for the right opportunity to arise. Eventually, an estate in Castelnuovo dell’Abate
                        in southern Tuscany came on the market and he snapped it up quicker than you could blink.
                        Working closely with the scholars of the University of Milan for the perfect Sangiovese clones
                        (only single variety would do), together they built a plan of optimisation of vineyards from
                        planting to pruning. Opting for a 100% organic approach, Piero had struck gold; all aspects
                        united and he had the makings of a first-rate wine.
                    </div>

                    <div class="howto-title2">The Burgundy of Brunello</div>
                    <div class="howto-text">
                        Over the years built a reputation as one of Brunello’s leading (and perhaps the most unpleasant)
                        producers. Palmucci sold Poggio di Sotto to Claudio Tipa, owner of ColleMassari and Grattamacco,
                        in 2011, and thankfully Tipa has continued to operate to the same quality standards and
                        production techniques as Poggio’s predecessor. This includes extremely low yields and extensive
                        botti ageing which combined produce what critics, collectors and investors refer to as “the
                        Burgundy of Brunello”.
                    </div>

                    <div class="howto-title2">Brunello is a diamond among Tuscan wines</div>
                    <div class="howto-text">
                        Poggio di Sotto owes its stellar reputation to the three sublime Montalcinos: the Rosso, the Brunello and the iconic Riserva. In 2001 the estate also produced the silky smooth and
                        increasingly scarce Brunello di Montalcino Il Decennale. This latter wine showed superb growth
                        from April 2017-2019, growing 100% over 24 months. The Rosso is considered by many to be a
                        better wine than many other Brunellos, while the Riserva has only been made four times since
                        1991. Quality and rarity certainly come at a price but believe us, it is worth it.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "FattoriaPoggioSotto",
    head: {
        title: 'Fattoria Poggio di Sotto | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the essence of Tuscany with Fattoria Poggio di Sotto, a renowned wine producer known for their exceptional quality and diverse range of wines. Experience the traditional winemaking techniques and rich heritage of the region with a sip from one of their beautifully crafted wines.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    },
    data() {
        return {
            select: {report: 'Fattoria Poggio di Sotto', src: '/wine-guide/italy/tuscany/fattoria-poggio-di-sotto'},
            items: [
                {report: 'Avignonesi', src: '/wine-guide/italy/tuscany/аvignonesi'},
                {
                    report: 'Azienda Agricola Casanova di Neri',
                    src: '/wine-guide/italy/tuscany/azienda-agricola-casanova-di-neri'
                },
                {report: 'Azienda Salvioni', src: '/wine-guide/italy/tuscany/azienda-salvioni'},
                {report: 'Castiglione del Bosco', src: '/wine-guide/italy/tuscany/castiglione-del-bosco'},
                {report: 'Conti Constani', src: '/wine-guide/italy/tuscany/conti-constani'},
                {report: 'Fattoria Le Pupille', src: '/wine-guide/italy/tuscany/fattoria-le-pupille'},
                {report: 'Fattoria Poggio di Sotto', src: '/wine-guide/italy/tuscany/fattoria-poggio-di-sotto'},
                {report: 'Fontodi', src: '/wine-guide/italy/tuscany/fontodi'},
                {report: 'Frescobaldi', src: '/wine-guide/italy/tuscany/frescobaldi'},
                {report: 'Gianfranco Soldera', src: '/wine-guide/italy/tuscany/gianfranco-soldera'},
                {report: 'Isole e Olena', src: '/wine-guide/italy/tuscany/isole-e-olena'},
                {report: 'Marchesi Antinori', src: '/wine-guide/italy/tuscany/marchesi-antinori'},
                {report: 'Podere Poggio Scalette', src: '/wine-guide/italy/tuscany/podere-poggio-scalette'},
                {report: 'Poderi Boscarelli', src: '/wine-guide/italy/tuscany/poderi-boscarelli'},
                {report: 'Tenuta dell’Ornellaia', src: '/wine-guide/italy/tuscany/tenuta-dell-ornellaia'},
                {report: 'Tenuta di Trinoro', src: '/wine-guide/italy/tuscany/tenuta-di-trinoro'},
                {report: 'Tenuta San Guido', src: '/wine-guide/italy/tuscany/tenuta-san-guido'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
